module.exports = __webpack_public_path__ + "static/media/moistrol-1.56d7d7da.jpg";